import { combineReducers } from "redux";
import { auth, getCountryCode, postLogout } from "./auth";
import { getBookingList, getBookingDetails, addBooking,updateBooking, getCancelReason, getBookingBufferTime, getCompanyCity, getCompanyService, getAirportTerminalList } from "./ReservationReducer";
import { getEmployeesList, getEmployeeDetails} from "./EmployeesReducer";

import { userCity } from "./UserServiceCity";
import { userCar,userCarFacilities } from "./UserCar";
import { userDutyType } from "./UserDutyType";
import { userCompanyDetails } from "./CompanyReducer";
import { userRateCard } from "./UserRateCard";
import { userAutoComplete, userDirection, userGeocode, userPlaceDetails } from "./UserGoogleMap";
import { cancelTrip, getCancelTripCharges } from "./OperationsReducer";
import { commonReducer } from "./commonReducer";
import { userBilling, userBillingApproval } from "./BillingReducer";
import { userRateCalculation } from "./UserRateCalculation";
import { userProfile } from "./ProfileReducer";
import { userRideDetails } from "./UserDashboard";
import { accountDeletion } from "./accountDeletion";

const rootReducer = combineReducers({
  auth: auth,
  getCountryCode: getCountryCode,
  commonReducer: commonReducer,
  getEmployeesList: getEmployeesList,
  getEmployeeDetails: getEmployeeDetails,
  getBookingList: getBookingList,
  getBookingBufferTime: getBookingBufferTime,
  getBookingDetails: getBookingDetails,
  addBooking: addBooking,
  updateBooking: updateBooking,
  userCity: userCity,
  userCar: userCar,
  userProfile: userProfile,
  userDutyType: userDutyType,
  cancelTrip: cancelTrip,
  cancelationTripCharges: getCancelTripCharges,
  userCompanyDetails:userCompanyDetails,
  userRateCard:userRateCard,
  userPlaceDetails:userPlaceDetails,
  userAutoComplete:userAutoComplete,
  userDirection:userDirection,
  userGeocode:userGeocode,
  userBilling:userBilling,
  userBillingApproval:userBillingApproval,
  userRateCalculation:userRateCalculation,
  getAirportTerminalList: getAirportTerminalList,
  getCancelReason:getCancelReason,
  getCompanyCity:getCompanyCity,
  getCompanyService:getCompanyService,
  postLogout: postLogout,
  userCarFacilities:userCarFacilities,
  userRideDetails:userRideDetails,
  accountDeletion: accountDeletion
});

export default rootReducer;
